<template>
  <div class="energytop">
    <div class="before_border">
      <van-field
        :value="value"
        clickable
        input-align="right"
        label="选择区域"
        name="area"
        placeholder="点击选择区域"
        readonly
        @click="showArea = true"
      >
        <template #right-icon>
          <img :src="require('../assets/home/down.png')" alt="" />
        </template>
      </van-field>
    </div>
    <div class="before_border">
      <slot name="input"></slot>
    </div>
    <van-popup v-if="showArea" v-model="showArea" position="bottom">
      <van-area
        :area-list="areaList"
        @cancel="showArea = false"
        @confirm="onConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
export default {
  // 树形结构，默认值
  props: ["areaList", "defvalue"],
  data() {
    return {
      value: "",
      showArea: false,
    };
  },
  methods: {
    ondefvalue(e) {
      this.onConfirm(e);
    },
    onConfirm(value) {
      console.log(this.areaList);
      this.value = value
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
      this.changeId(value);
    },
    changeId(value) {
      // code name
      this.$emit("code", value);
    },
  },
};
</script>

<style lang="less" scoped>
.energytop {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  position: relative;
}

.before_border {
  position: relative;
  display: flex;
  width: 97%;

  img {
    vertical-align: middle;
    width: 15px;
    height: 15px;
  }
}

.van-dropdown-menu__item {
  background-color: #fff !important;
}

.van-dropdown-menu {
  width: 100%;
  background-color: #fff;
}
</style>
